import React from 'react'
import Header from '../standartComponents/header'
import RoadMap from './roadMap'
import css from './roadMap.module.css';
import Policies from '../standartComponents/policies';

const RoadMapMain = ({authUser}) => {
  return (
    <div className={css.roadMapWrap}>
    <Header authUser={authUser}  />
    <RoadMap />
    </div>
  )
}

export default RoadMapMain